<template>
  <div class="leaderboard-prizes" v-if="first || second || third || text">
    <b-card-group class="mx-0 text-center">

      <prize-item v-if="first && !first.hidden" :hideDescriptions="hideDescriptions" :prize="first" :raffle-mode="isRaffle">
        <template v-slot:position>
          <h4 v-if="isRaffle && (second || third)">{{ $t('leaderboards.prizes.prize-1-label') }}</h4>
          <h4 v-else-if="!isRaffle">
            <img src="/static/images/icons/medals/gold-medal.svg" /><br/>
            <span class="d-block d-sm-inline-block">{{ $t('leaderboards.prizes.first-label') }}</span>
          </h4>
        </template>
        <template v-slot:held-by v-if="!isRaffle && Array.isArray(scores)">
          <template v-if="scores[0] && scores[0].score > 0">
            <template v-if="isDepartmentLeaderboard">
              <div class="contact-name"><b>{{scores[0].entry.name}}</b></div>
            </template>
            <template v-else>
              <div class="contact-name"><b>{{scores[0].entry.fullName}}</b></div>
              <div class="jobTitle grey">{{scores[0].entry.title}}</div>
            </template>
          </template>
          <template v-else>
            <div class="contact-name">&nbsp;</div>
            <div class="jobTitle grey">&nbsp;</div>
          </template>
        </template>
      </prize-item>

      <prize-item v-if="second && !second.hidden" :hideDescriptions="hideDescriptions" :prize="second" :raffle-mode="isRaffle">
        <template v-slot:position>
          <h4 v-if="isRaffle && (first || third)">{{ $t('leaderboards.prizes.prize-2-label') }}</h4>
          <h4 v-if="!isRaffle">
            <img src="/static/images/icons/medals/silver-medal.svg" /><br/>
            <span class="d-block d-sm-inline-block">{{ $t('leaderboards.prizes.second-label') }}</span>
          </h4>
        </template>
        <template v-slot:held-by v-if="!isRaffle && Array.isArray(scores)">
          <template v-if="scores[1] && scores[1].score > 0">
            <template v-if="isDepartmentLeaderboard">
              <div class="contact-name"><b>{{scores[1].entry.name}}</b></div>
            </template>
            <template v-else>
              <div class="contact-name"><b>{{scores[1].entry.fullName}}</b></div>
              <div class="jobTitle grey">{{scores[1].entry.title}}</div>
            </template>
          </template>
          <template v-else>
            <div class="contact-name">&nbsp;</div>
            <div class="jobTitle grey">&nbsp;</div>
          </template>
        </template>
      </prize-item>

      <prize-item v-if="third && !third.hidden" :hideDescriptions="hideDescriptions" :prize="third" :raffle-mode="isRaffle">
        <template v-slot:position>
          <h4 v-if="isRaffle && (first || second)">{{ $t('leaderboards.prizes.prize-3-label') }}</h4>
          <h4 v-if="!isRaffle">
            <img src="/static/images/icons/medals/bronze-medal.svg" /><br/>
            <span class="d-block d-sm-inline-block">{{ $t('leaderboards.prizes.third-label') }}</span>
          </h4>
        </template>
        <template v-slot:held-by v-if="!isRaffle && Array.isArray(scores)">
          <template v-if="scores[2] && scores[2].score > 0">
            <template v-if="isDepartmentLeaderboard">
              <div class="contact-name"><b>{{scores[2].entry.name}}</b></div>
            </template>
            <template v-else>
              <div class="contact-name"><b>{{scores[2].entry.fullName}}</b></div>
              <div class="jobTitle grey">{{scores[2].entry.title}}</div>
            </template>
          </template>
          <template v-else>
            <div class="contact-name">&nbsp;</div>
            <div class="jobTitle grey">&nbsp;</div>
          </template>
        </template>
      </prize-item>

    </b-card-group>

    <b-card class="border-0" v-if="text">
      <div class="position grey">
        <h4 v-if="isRaffle">🎟 {{ $t('leaderboards.prizes.text-label') }}</h4>
        <h4 v-else><img class="mr-1" src="/static/images/icons/medals/bronze-medal.svg" /> {{ $t('leaderboards.prizes.text-label') }}</h4>
      </div>
      <p class="black">{{text}}</p>
    </b-card>
  </div>
</template>

<script>
import PrizeItem from './Prize-Item';

export default {
  props: {
    first: {
      type: Object,
      default: () => null,
    },
    second: {
      type: Object,
      default: () => null,
    },
    third: {
      type: Object,
      default: () => null,
    },
    text: {
      type: String,
      default: () => null,
    },
    hideDescriptions: {
      type: Boolean,
      default: false,
    },
    isDepartmentLeaderboard: {
      type: Boolean,
      default: () => false,
    },
    isRaffle: {
      type: Boolean,
      default: () => false,
    },
    scores: {
      type: Array,
      default: () => null,
    },
  },
  components: {
    PrizeItem,
  },
};
</script>

<style lang="scss">
.leaderboard-prizes {
  .card-deck {
    flex-direction: row;
    flex-flow: row wrap;

    .card {
      flex: 1 0 0%;
    }
  }

  .card {
    .img-fluid {
      max-height: 300px;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/leaderboards/Prizes.vue